import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';
import { RequestTypeDropdownComponent } from '../DomainData/RequestTypeDropdown.component';
import { EquipmentClassDropdownComponent } from '../DomainData/EquipmentClassDropdown.component';
import { EquipmentLineItemTypeDropdownComponent } from '../DomainData/EquipmentLineItemTypeDropdown.component';
import { ExportFileDropdownComponent } from '../Exports/ExportFileDropdown.component';
import { ActivityReasonDropdownComponent } from '../DomainData/ActivityReasonDropdown.component';
import { dropDownValidator, hiddenDropDownValueValidator } from '../../validators/CustomValidators';

@Component({
  selector: 'my-equipmenttemplaterule-edit',
  templateUrl: './EquipmentTemplateRuleEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => EquipmentTemplateRuleEditComponent)}]
})
export class EquipmentTemplateRuleEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @Input() public record: ent.EquipmentTemplateRule;

    @ViewChild(RequestTypeDropdownComponent) public requestTypeDropdownComponent: RequestTypeDropdownComponent;
    @ViewChild(ActivityReasonDropdownComponent) public activityReasonDropdownComponent: ActivityReasonDropdownComponent;
    @ViewChild(EquipmentClassDropdownComponent) public equipmentClassDropdownComponent: EquipmentClassDropdownComponent;
    @ViewChild(EquipmentLineItemTypeDropdownComponent) public equipmentLineItemTypeDropdownComponent: EquipmentLineItemTypeDropdownComponent;
    @ViewChild(ExportFileDropdownComponent) public exportFileDropdownComponent: ExportFileDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'shortDescription' : '',
          'description' : '',
          'notificationType' : '',
          'codingA' : '',
          'codingB' : '',
          'specialEvent' : '',
          'serializedAsset' : '',
          'survey' : '',
          'activityReason' : '',
          'equipmentClass' : '',
          'hidEquipmentClass' : '',
          'equipmentLineItemType' : '',
          'hidEquipmentLineItemType' : '',
          'exportFile' : '',
          'requestType' : '',
          'hidRequestType' : ''
        };
        
        this.form = fb.group(group);
    }


    ngOnInit(): void {
        this.form.controls['requestType'].setValidators(dropDownValidator);
        this.form.controls['hidRequestType'].setValidators(hiddenDropDownValueValidator);

        // this.form.controls['equipmentClass'].setValidators(dropDownValidator);
        // this.form.controls['hidEquipmentClass'].setValidators(hiddenDropDownValueValidator);

        this.form.controls['equipmentLineItemType'].setValidators(dropDownValidator);
        this.form.controls['hidEquipmentLineItemType'].setValidators(hiddenDropDownValueValidator);
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    requestTypeSelected(){
        var val = true;
        var form = this.form;
        if (form.controls.requestType.errors && form.controls.hidRequestType.errors){
            if (form.controls.requestType.errors.invalid && form.controls.hidRequestType.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    equipmentClassSelected(){
        var val = true;
        var form = this.form;
        if (form.controls.equipmentClass.errors && form.controls.hidEquipmentClass.errors){
            if (form.controls.equipmentClass.errors.invalid && form.controls.hidEquipmentClass.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    equipmentLineItemTypeSelected(){
        var val = true;
        var form = this.form;
        if (form.controls.equipmentLineItemType.errors && form.controls.hidEquipmentLineItemType.errors){
            if (form.controls.equipmentLineItemType.errors.invalid && form.controls.hidEquipmentLineItemType.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    requestTypeChange(event: any){
        
        this.record.RequestTypeID = event;
    }

    activityReasonChange(event: any){
        
        this.record.ActivityReasonID = event;
        if (event < 0){
            this.record.ActivityReasonID = null;
        }
    }

    equipmentClassChange(event: any){
        
        this.record.EquipmentClassID = event;
    }

    equipmentLineItemTypeChange(event: any){
        
        this.record.EquipmentLineItemTypeID = event;
    }

    exportFileChange(event: any){
        
        this.record.ExportFileID = event;
        if (event < 0){
            this.record.ExportFileID = null;
        }
    }
    

    
}